export const formatPrice = (price: number, isAddUnit: boolean = true): string => {
  const unit = isAddUnit ? " 円" : "";
  return price.toLocaleString("ja-JP") + unit;
};
